import { computed } from 'vue';
import { Watchlist, WatchlistQuery } from '@libs/api-reference';
import { useQueryV2 } from '@libs/use';

import * as API from '../requests';
import { WATCHLIST_QUERY_KEYS } from '../constants';

export default function useGetWatchlist() {
  const {
    execute: getWatchlist,
    isPending: isLoadingWatchlist,
    isRevalidating: isRevalidatingWatchlist,
    isSuccess: isSuccessLoadingWatchlist,
    isError: isErrorLoadingWatchlist,
    result,
    status: watchlistStatus,
    ...query
  } = useQueryV2<WatchlistQuery>(API.getWatchlist, {
    key: WATCHLIST_QUERY_KEYS.watchlist,
  });

  const watchList = computed<Watchlist[]>(() => result.value?.data.items || []);

  return {
    getWatchlist,
    watchList,
    isLoadingWatchlist,
    isRevalidatingWatchlist,
    isSuccessLoadingWatchlist,
    isErrorLoadingWatchlist,
    watchlistStatus,
    ...query,
  };
}
